<template>
  <div class="peer-assmnt__criteria_leave-feedback">
    <template v-if="editing == 'notes'">
      <div class="grade-feedback-editor__title">
        Leave Overall Feedback
      </div>

      <div class="grade-feedback-editor__edit">
        <quill
          v-model="notes"
          @focus="editing = 'notes'"
          @blur="save"
          @change="changeNotes"
          toolbarType="minimal"
          placeholder="Leave some overall feedback..."
        ></quill>

        <span class="quill-required-error hide">
          {{ I18n.t('required_field') }}
        </span>
      </div>
    </template>

    <a
      v-else-if="!notes.length && editing != 'notes'"
      class="grade-feedback-editor__link"
      href='javascript:;'
      @click="editing = 'notes'"
    >
      Leave Overall Feedback
    </a>

    <template v-else>
      <div class="grade-feedback-editor__title">
        Overall Feedback
      </div>

      <a
        class="grade-feedback-editor__preview"
        @click="editing = 'notes'"
      >
        <span class="grade-feedback-editor__preview_copy" v-html="notes" />

        <span class="grade-feedback-editor__preview_edit-btn">
          <i class="kf kf-pencil" />
        </span>
      </a>
    </template>
  </div>
</template>

<script>
import Quill from 'libs/components/quill'

export default {
  props: ['peer_entry'],

  components: {
    Quill
  },

  data() {
    return {
      old_notes: null,
      editing: null
    };
  },

  computed: {
    notes: {
      get() {
        return this.peer_entry.grade.notes || '';
      },

      set(value) {
        this.peer_entry.grade.notes = value;
      }
    }
  },

  watch: {
    editing(value) {
      if (value !== null) {
        this.old_notes = this.notes;
      }
    }
  },

  methods: {
    changeNotes({ html }) {
      this.notes = html
    },

    save() {
      console.log('saving feedback.vue')
      if (this.editing === 'notes')
        this.old_notes = this.notes;

      this.editing = null;
    }
  }
};
</script>
